import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { UI } from '../UI';
import { User } from '../User';

import { ExportTo } from '../ExportTo';
import { pdfcss } from './pdfcss';

import './scss/productapproval.scss';

export const ProductApproval = (function () {
  let $el = {};
  let $product;
  let $licensedProductId;
  let $sections = [];

  let mapping = (product) => {
    // process dates
    product.artwork.uploadDate = moment(product.artwork.uploadDate).format($config.appFullDateFormat);
    product.blank.uploadDate = moment(product.blank.uploadDate).format($config.appFullDateFormat);
    product.details.submissionDate = moment(product.details.submissionDate).format($config.appFullDateFormat);
    product.details.approvalDate = moment(product.details.approvalDate).format($config.appFullDateFormat);
    product.details.approvalDuration.limitedDate = moment(product.details.approvalDuration.limitedDate).format(
      $config.appFullDateFormat
    );
    product.details.inStoreDate.noActivityBeforeDate.byDatePropDate = moment(
      product.details.inStoreDate.noActivityBeforeDate.byDatePropDate
    ).format($config.appFullDateFormat);
    product.details.inStoreDate.noActivityBeforeDate.byRangeDateFrom = moment(
      product.details.inStoreDate.noActivityBeforeDate.byRangeDateFrom
    ).format($config.appFullDateFormat);
    product.details.inStoreDate.noActivityBeforeDate.byRangeDateTo = moment(
      product.details.inStoreDate.noActivityBeforeDate.byRangeDateTo
    ).format($config.appFullDateFormat);

    // process blank variants
    const areaTypes = ['Front', 'Back', 'Left Sleeve', 'Right Sleeve', 'Inner Label'];
    product.blank.variants.forEach((variant) => {
      variant.blankVariantAreas.forEach((area) => {
        area.areaTypeName = areaTypes[area.areaType];
      });
    });

    // process canvas sizes and locations
    product.productCanvasSize.artworkForProductionItems.forEach((item) => {
      const sideImageAlignments = ['Centered', 'Left', 'Right'];
      item.alignmentName = sideImageAlignments[item.alignment];
      item.areaTypeName = areaTypes[item.areaType];
    });

    product.productSpecification.colors = product.productSpecification.availableColors.split(',');
    product.blank.colors = product.blank.colors.split(',');

    product.iniframe = window.self !== window.top;

    // map $sections
    $sections.push(product.productSpecification.approveItem);
    $sections.push(product.productMockups.approveItem);
    $sections.push(product.productCanvasSize.approveItem);
    $sections.push(product.artwork.approveItem);
    $sections.push(product.trimInnerLabel.approveItem);
    $sections.push(product.trimHangTag.approveItem);
    $sections.push(product.blank.approveItem);
    $sections.push(product.businessAndCommercials.approveItem);

    if (product.artwork && product.artwork.pantones) {
      product.artwork.pantones.forEach((item) => {
        item.hexadecimalname =
          item.hexadecimal && item.hexadecimal.length > 0 ? item.hexadecimal.substr(1) : item.hexadecimal;
      });
    }

    return product;
  };

  let init = (element, licensedProductId) => {
    $el = element;
    $licensedProductId = licensedProductId;
    UI.block(element);


    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}/regular`, {})).done((res) => {
      $product = mapping(res.data);
      pageInit($product);
    });
  };

  let pageInit = (product) => {
    let pageData = {
      ...{
        product,
        $lang: $lang
      }
    };

    let template = require('./tmpl/productapproval.hbs');
    UI.page(template, pageData, false).then(() => {
      // Init all UI elements
      approvalDateInit();
      approvalLimitedToDateInit();
      noActivityBeforeDateInit();
      noActivityBeforeDateRangeInit();

      // Page Loaded INFRAME PostMessage
      onLoadMessage();

      UI.unblock($el);
    });
  };

  let approvalDateInit = () => {
    let element = $('#approval-date-btn');
    element
      .daterangepicker(
        {
          buttonClasses: ' btn',
          applyClass: 'btn-primary',
          cancelClass: 'btn-secondary',
          singleDatePicker: true,
          showDropdowns: true,
          drops: 'up',
          opens: 'right',
          locale: {
            format: $config.appFullDateFormat
          }
        },
        function (start) {
          // Redraw selected date
          $('span', element).html(start.format($config.appFullDateFormat));
          // Update model
          $product.details.approvalDate = start.format($config.appFullDateFormat);
        }
      )
      .on('show.daterangepicker', () => {
        element.addClass('opened');
      })
      .on('hide.daterangepicker', () => {
        element.removeClass('opened');
      });
  };

  let approvalLimitedToDateInit = () => {
    let element = $('#limited-to-date-btn');
    element
      .daterangepicker(
        {
          buttonClasses: ' btn',
          applyClass: 'btn-primary',
          cancelClass: 'btn-secondary',
          singleDatePicker: true,
          showDropdowns: true,
          drops: 'up',
          opens: 'right',
          locale: {
            format: $config.appFullDateFormat
          }
        },
        function (start) {
          // Redraw selected date
          $('span', element).html(start.format($config.appFullDateFormat));
          // Update model
          $product.details.approvalDuration.limitedDate = start.format($config.appFullDateFormat);
        }
      )
      .on('show.daterangepicker', () => {
        element.addClass('opened');
      })
      .on('hide.daterangepicker', () => {
        element.removeClass('opened');
      });
  };

  let noActivityBeforeDateInit = () => {
    let element = $('#no-activity-before-date-btn');
    element
      .daterangepicker(
        {
          buttonClasses: ' btn',
          applyClass: 'btn-primary',
          cancelClass: 'btn-secondary',
          singleDatePicker: true,
          showDropdowns: true,
          drops: 'up',
          opens: 'right',
          locale: {
            format: $config.appFullDateFormat
          }
        },
        function (start) {
          // Redraw selected date
          $('span', element).html(start.format($config.appFullDateFormat));
          // Update model
          $product.details.inStoreDate.noActivityBeforeDate.byDatePropDate = start.format($config.appFullDateFormat);
        }
      )
      .on('show.daterangepicker', () => {
        element.addClass('opened');
      })
      .on('hide.daterangepicker', () => {
        element.removeClass('opened');
      });
  };

  let noActivityBeforeDateRangeInit = () => {
    let element = $('#no-activity-before-date-range-btn');
    element
      .daterangepicker(
        {
          buttonClasses: ' btn',
          applyClass: 'btn-primary',
          cancelClass: 'btn-secondary',
          startDate: $product.details.inStoreDate.noActivityBeforeDate.byRangeDateFrom,
          endDate: $product.details.inStoreDate.noActivityBeforeDate.byRangeDateTo,
          showDropdowns: true,
          drops: 'up',
          opens: 'right',
          locale: {
            format: $config.appFullDateFormat
          }
        },
        function (start, end) {
          // Redraw selected date
          $('span', element).html(
            start.format($config.appFullDateFormat) + ' - ' + end.format($config.appFullDateFormat)
          );
          // Update model
          $product.details.inStoreDate.noActivityBeforeDate.byRangeDateFrom = start.format($config.appFullDateFormat);
          $product.details.inStoreDate.noActivityBeforeDate.byRangeDateTo = end.format($config.appFullDateFormat);
        }
      )
      .on('show.daterangepicker', () => {
        element.addClass('opened');
      })
      .on('hide.daterangepicker', () => {
        element.removeClass('opened');
      });
  };

  let onLoadMessage = () => {
    if (window.self === window.top) return;
    if (window.parent) {
      window.parent.postMessage({ pageloaded: true, FileId: $product.fileId }, '*');
    }
  };

  let approve = (id) => {
    var section = $sections.find((s) => s.section == id);
    section.approved = true;
    section.comments = null;


    $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}`, section, 'PUT')).done(
      () => {
        init($el, $licensedProductId);
      }
    );
  };

  let disapprove = (id) => {
    var section = $sections.find((s) => s.section == id);

    bootbox.prompt({
      size: 'medium',
      title: $lang.productApproval.artwork.Comments,
      message: section.sectionName,
      value: section.comments,
      callback: function (result) {
        section.approved = false;
        section.comments = result;

        $.when(App.ajaxData(`LicensedProductApprove/${User.accountID()}/${$licensedProductId}`, section, 'PUT')).done(
          () => {
            init($el, $licensedProductId);
          }
        );
      }
    });
  };

  let apply = () => {
    $product.details.revisedBy = $('#revised-by').val();
    $product.details.approvedBy = $('#approved-by').val();
    $product.details.comments = $('#details-comments').val();
    $.when(App.ajaxData(`LicensedProductApprove/details/${$licensedProductId}`, $product.details, 'PUT')).done(() => {
      init($el, $licensedProductId);
    });
  };

  let exportToPdf = () => {
    ExportTo.pdf({
      css: pdfcss
    });
  };

  return {
    init,
    approve,
    disapprove,
    apply,
    exportToPdf
  };
})();
